// Llamadas al servidor. Un error trae el mensaje para mostrar y el código HTTP en `status`
// (0 sin conexión; 401 requiere sesión; 404 no existe o no es tuyo; 409 el estado no lo permite…).
export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

async function request(method, url, body, { keepalive = false } = {}) {
  const write = method !== 'GET' && method !== 'HEAD';
  let r;
  try {
    r = await fetch(url, {
      method,
      // Todo lo que cambia algo va como JSON, aunque no lleve datos: el servidor lo exige (protección CSRF).
      headers: write ? { 'Content-Type': 'application/json' } : {},
      body: write ? JSON.stringify(body ?? {}) : undefined,
      credentials: 'same-origin',
      keepalive,
    });
  } catch {
    throw new ApiError('Sin conexión con el servidor', 0);
  }
  const type = r.headers.get('content-type') || '';
  if (!type.includes('application/json')) {
    if (r.redirected || type.includes('text/html')) throw new ApiError('La sesión expiró: recarga la página para volver a entrar', r.status);
    throw new ApiError(`Respuesta inesperada del servidor (${r.status})`, r.status);
  }
  let data;
  try {
    data = await r.json();
  } catch {
    throw new ApiError(`Respuesta inesperada del servidor (${r.status})`, r.status);
  }
  if (!r.ok) throw new ApiError(data.error || `Error ${r.status}`, r.status);
  return data;
}

export const api = {
  get: (url) => request('GET', url),
  post: (url, body, opts) => request('POST', url, body, opts),
  put: (url, body, opts) => request('PUT', url, body, opts),
  del: (url, body) => request('DELETE', url, body),
};
